// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"CustomerWiseAPIStockPage_inputContainer__HOdkk"};